var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("path",{"fill":"none","d":"M0 16V0h16v16z","key":0}),React.createElement("path",{"fill":"#53647f","d":"M.929 10.828l5.657-5.656L8 3.757l1.414 1.415 5.657 5.656-1.414 1.415L8 6.586l-5.657 5.657-1.414-1.415z","key":1})])));
}

ChevronUp.defaultProps = {"width":"16","height":"16"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
